import { setCustomIconsLoader } from 'iconify-icon'

// Lazy-load the custom icon collection JSON chunk on first request
const iconCollectionPromise = import(
  /* webpackChunkName: "iconify-collection" */ '@/images/icons/iconify-tc.json'
).then((module) => module.default ?? module)

// Register the custom loader synchronously — this must happen before any
// tc: icon is rendered, so the web component never falls back to the API.
// setCustomIconsLoader is called with the loader function and prefix "tc".
setCustomIconsLoader(async (names) => {
  try {
    return await iconCollectionPromise
  } catch (error) {
    console.warn('Unable to load custom Iconify collection', error)
    return null
  }
}, 'tc')

// No-op export kept for backwards compatibility with base.js
export const initIconifyCollection = () => Promise.resolve(true)
